import type { InputHTMLAttributes, ReactElement } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
}

export function Input({ label, error, className = '', ...rest }: InputProps): ReactElement {
    const baseClass =
        'w-full rounded border border-gray-300 px-3 py-2 text-sm focus:border-gray-900 focus:outline-none disabled:bg-gray-100';
    const errorClass = error ? ' border-red-500' : '';

    return (
        <label className="block">
            {label && <span className="mb-1 block text-sm text-gray-700">{label}</span>}
            <input className={`${baseClass}${errorClass} ${className}`} {...rest} />
            {error && <span className="mt-1 block text-xs text-red-600">{error}</span>}
        </label>
    );
}
